module.exports = __webpack_public_path__ + "img/login-logo.9fe45804.png";